import 'emoji-picker-element'
import ja from 'emoji-picker-element/i18n/ja'

const PICKER_SEL = 'emoji-picker'
const FIELD_SEL = '.chatbox__field, .streamer-profile-pc-comment-form__field'
const bindings = [
  {
    root: '.streamer-profile-pc-comment-form__emoji',
    button: '.streamer-profile-pc-comment-form__emoji-btn',
    popover: '.streamer-profile-pc-comment-form__emoji-popover',
    textarea: '.streamer-profile-pc-comment-form__textarea',
  },
  {
    root: '.chatbox__emoji',
    button: '.chatbox__emoji-btn',
    popover: '.chatbox__emoji-popover',
    textarea: 'textarea',
  },
]

function insertAtCursor(textarea, text) {
  const max = parseInt(textarea.getAttribute('maxlength'), 10)
  const start = textarea.selectionStart ?? textarea.value.length
  const end = textarea.selectionEnd ?? textarea.value.length
  const next = textarea.value.slice(0, start) + text + textarea.value.slice(end)
  if (Number.isFinite(max) && next.length > max) return
  textarea.value = next
  const caret = start + text.length
  textarea.setSelectionRange(caret, caret)
  textarea.dispatchEvent(new Event('input', { bubbles: true }))
  textarea.focus()
}

function closePopover(root, config) {
  const btn = root.querySelector(config.button)
  const popover = root.querySelector(config.popover)
  if (!popover || popover.hidden) return
  popover.hidden = true
  if (btn) btn.setAttribute('aria-expanded', 'false')
}

function openPopover(root, config) {
  const btn = root.querySelector(config.button)
  const popover = root.querySelector(config.popover)
  if (!popover) return
  popover.hidden = false
  if (btn) btn.setAttribute('aria-expanded', 'true')
}

function togglePopover(root, config) {
  const popover = root.querySelector(config.popover)
  if (!popover) return
  if (popover.hidden) openPopover(root, config)
  else closePopover(root, config)
}

function bindRoot(root, config) {
  if (root.dataset.emojiPickerBound === '1') return
  const btn = root.querySelector(config.button)
  const popover = root.querySelector(config.popover)
  const picker = root.querySelector(PICKER_SEL)
  const field = root.closest(FIELD_SEL)
  const textarea = field?.querySelector(config.textarea)
  if (!btn || !popover || !picker || !textarea) return
  root.dataset.emojiPickerBound = '1'

  picker.i18n = ja

  btn.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    togglePopover(root, config)
  })

  picker.addEventListener('emoji-click', (e) => {
    const unicode = e.detail?.unicode
    if (!unicode) return
    insertAtCursor(textarea, unicode)
  })

  document.addEventListener('click', (e) => {
    if (popover.hidden) return
    if (root.contains(e.target)) return
    closePopover(root, config)
  })
}

function boot() {
  bindings.forEach((config) => {
    document.querySelectorAll(config.root).forEach((root) => bindRoot(root, config))
  })
}

document.addEventListener('DOMContentLoaded', boot)
document.addEventListener('turbolinks:load', boot)
document.addEventListener('turbo:load', boot)
boot()
